// src/data/planesInfo.js
export const PLANES_DETALLES = {
  // 1. MUJER - BÁSICO GYM
  'Plan Mujer Basico Gym': {
    titulo: 'Plan Básico Mujer – Gimnasio',
    categoriaKey: 'plan_basico_mujer_-_gym',
    descripcion:
      'Este plan está diseñado para mujeres que están comenzando a entrenar o retomando la actividad física en gimnasio. Su objetivo es desarrollar fuerza general, aprender la técnica correcta en máquinas con ejercicios guiados, y construir una base sólida de entrenamiento. Entrenarás 3 días a la semana, con sesiones de 45 a 60 minutos, siguiendo una estructura clara que te permitirá progresar de forma segura. Este programa busca mejorar tu condición física y ayudarte a generar constancia en el entrenamiento. Para mejores resultados, se recomienda complementar con una alimentación adecuada y buen descanso. A medida que avances, podrás progresar a planes de mayor intensidad. No recomendado para personas con lesiones sin supervisión profesional. Resultados esperados: mejoras en fuerza, coordinación y resistencia muscular en 4 a 6 semanas.',
    comoUsar: [
      'Comienza con calentamiento en máquinas de cardio + movilidad (video).',
      'Ejecuta cada ejercicio con control, priorizando la técnica.',
      'Empieza con los músculos grandes, luego los pequeños.',
      'Descansa entre 60 a 90 segundos entre series.',
      'Mantén una buena hidratación.',
      'Finaliza con elongación (video).'
    ],
    carga: [
      'Ajusta la carga para que las últimas repeticiones cuesten, dejando 2–3 repeticiones en reserva.',
      'Si completas fácilmente, aumenta la carga en la siguiente sesión.'
    ],
    importante: [
      'Respira de forma consciente durante todo el entrenamiento. La respiración es fundamental para ejecutar cada ejercicio con seguridad y eficiencia. Inhala al preparar el movimiento y exhala durante la fase de mayor esfuerzo. Mantén un ritmo constante y evita contener el aire. Una buena respiración mejora el control, la estabilidad, el rendimiento y la correcta ejecución de cada ejercicio.',
      'Si no logras completar las repeticiones, disminuye la carga.',
      'Prioriza siempre la técnica antes de aumentar el peso.'
    ],
    objetivos: [
      'Aprender técnica en máquinas y ejercicios básicos',
      'Desarrollar fuerza general',
      'Mejorar resistencia y coordinación',
      'Generar hábito de entrenamiento'
    ]
  },

  // 2. MUJER - BÁSICO CASA
  'Plan Mujer Basico Casa': {
    titulo: 'Plan Básico Mujer – Casa',
    categoriaKey: 'plan_basico_mujer_-_casa',
    descripcion:
      'Este plan está enfocado en mujeres que entrenan en casa utilizando implementos básicos como mancuernas, barras, discos, TRX, tobilleras, etc. Su objetivo es desarrollar fuerza general, mejorar el control corporal y construir una base sólida de entrenamiento en casa. Entrenarás 3 días a la semana, con sesiones de 45 a 60 minutos. Este programa busca mejorar tu condición física y ayudarte a mantener constancia desde casa. Para mejores resultados, se recomienda complementar con una alimentación adecuada y buen descanso. A medida que avances, podrás aumentar la carga, las repeticiones o la dificultad de los ejercicios. No recomendado para personas con lesiones sin supervisión profesional. Resultados esperados: mejoras en fuerza, coordinación y control corporal en 4 a 6 semanas.',
    comoUsar: [
      'Comienza con movilidad + activación (videos).',
      'Empieza con los músculos grandes, luego los pequeños.',
      'Mantén una buena postura en cada ejercicio.',
      'Controla los movimientos (evita hacerlos rápido).',
      'Descansa entre 60 a 90 segundos entre series.',
      'Mantén una buena hidratación.',
      'Finaliza con elongación (video).'
    ],
    carga: [
      'Ajusta la carga para que las últimas repeticiones cuesten, dejando 2–3 repeticiones en reserva.',
      'Si completas fácilmente, aumenta la carga.',
      'Si no tienes suficiente peso aumenta repeticiones disminuye la velocidad del movimiento.',
      'Progresa gradualmente semana a semana.'
    ],
    importante: [
      'Respira de forma consciente durante todo el entrenamiento. La respiración es fundamental para ejecutar cada ejercicio con seguridad y eficiencia. Inhala al preparar el movimiento y exhala durante la fase de mayor esfuerzo. Mantén un ritmo constante y evita contener el aire. Una buena respiración mejora el control, la estabilidad, el rendimiento y la correcta ejecución de cada ejercicio.',
      'Si no logras completar las repeticiones, disminuye la carga.',
      'Prioriza siempre la técnica antes de aumentar el peso.'
    ],
    objetivos: [
      'Aprender movimientos básicos con técnica',
      'Activar el cuerpo completo',
      'Desarrollar fuerza inicial y control corporal',
      'Generar hábito de entrenamiento'
    ]
  },

  // 3. MUJER - INTERMEDIO GYM
  'Plan Mujer Intermedio Gym': {
    titulo: 'Plan Intermedio Mujer – Gimnasio',
    categoriaKey: 'plan_intermedio_mujer_-_gimnasio',
    descripcion:
      'Este plan está diseñado para personas que ya tienen experiencia entrenando y buscan progresar en fuerza, tonificación y desarrollo muscular, con énfasis en tren inferior. Incluye mayor volumen de trabajo, mayor carga, ejercicios más exigentes y control en la ejecución. Entrenarás 3 días a la semana, con sesiones de aproximadamente 45 a 60 minutos. Para obtener resultados óptimos, es fundamental complementar con una alimentación adecuada, buen descanso y una correcta recuperación. A medida que avances, podrás progresar hacia entrenamientos más intensos y específicos. Este plan no es recomendado para principiantes ni para personas con lesiones sin supervisión profesional. Resultados esperados: mejoras en fuerza, masa muscular y rendimiento en 4 a 6 semanas si se mantiene la constancia.',
    comoUsar: [
      'Realiza primero el calentamiento en máquinas de cardio + movilización (video).',
      'Comienza con los músculos grandes, luego los pequeños.',
      'Mantén una ejecución técnica correcta en cada ejercicio.',
      'Descansa entre 60 a 90 segundos entre cada serie.',
      'Mantén una buena hidratación.',
      'Finaliza con elongación (video).'
    ],
    carga: [
      'Ajusta la carga para que las últimas repeticiones cuesten, dejando 2–3 repeticiones en reserva.',
      'Si puedes completar todas las repeticiones sin dificultad, aumenta la carga en la siguiente sesión.',
      'Busca progresar gradualmente semana a semana.'
    ],
    importante: [
      'Respira de forma consciente durante todo el entrenamiento. La respiración es fundamental para ejecutar cada ejercicio con seguridad y eficiencia. Inhala al preparar el movimiento y exhala durante la fase de mayor esfuerzo. Mantén un ritmo constante y evita contener el aire. Una buena respiración mejora el control, la estabilidad, el rendimiento y la correcta ejecución de cada ejercicio.',
      'Si no logras completar las repeticiones, disminuye la carga.',
      'Prioriza siempre la técnica antes de aumentar el peso.'
    ],
    objetivos: [
      'Aumentar masa muscular y fuerza',
      'Desarrollar glúteos y piernas',
      'Mejorar fuerza en tren inferior',
      'Mejorar estabilidad y control corporal'
    ]
  },

  // 4. MUJER - INTERMEDIO CASA
  'Plan Mujer Intermedio Casa': {
    titulo: 'Plan Intermedio Mujer – Casa',
    categoriaKey: 'plan_intermedio_mujer_-_casa',
    descripcion:
      'Este plan está orientado a personas con nivel intermedio que entrenan en casa y buscan progresar en fuerza, tonificación y control corporal. Incluye mayor volumen de entrenamiento, ejercicios más desafiantes, mayor carga, y uso de implementos como mancuernas, discos, TRX, etc. Entrenarás 3 días a la semana, con sesiones de aproximadamente 45 a 60 minutos. Para obtener resultados óptimos, es fundamental complementar con una alimentación adecuada, buen descanso y una correcta recuperación. A medida que avances, podrás progresar hacia entrenamientos más intensos y específicos. Este plan no es recomendado para principiantes ni para personas con lesiones sin supervisión profesional. Resultados esperados: mejoras en fuerza, masa muscular y rendimiento en 4 a 6 semanas si se mantiene la constancia.',
    comoUsar: [
      'Comienza con movilidad + cardio suave + activación de core.',
      'Empieza con los músculos grandes, luego los pequeños.',
      'Mantén control en cada repetición.',
      'Descansa entre 60 a 90 segundos entre cada serie.',
      'Mantén una buena hidratación.',
      'Finaliza con elongación.'
    ],
    carga: [
      'Ajusta la carga para que las últimas repeticiones cuesten (2–3 repeticiones en reserva).',
      'Si es fácil, aumenta el peso, repeticiones o controla el ritmo del movimiento.',
      'Busca progresar gradualmente semana a semana.'
    ],
    importante: [
      'Respira de forma consciente durante todo el entrenamiento. La respiración es fundamental para ejecutar cada ejercicio con seguridad y eficiencia. Inhala al preparar el movimiento y exhala durante la fase de mayor esfuerzo. Mantén un ritmo constante y evita contener el aire. Una buena respiración mejora el control, la estabilidad, el rendimiento y la correcta ejecución de cada ejercicio.',
      'Si no logras completar las repeticiones, disminuye la carga.',
      'Prioriza siempre la técnica antes de aumentar el peso.'
    ],
    objetivos: [
      'Aumentar fuerza y tonificación en casa',
      'Desarrollar glúteos y piernas',
      'Mejorar estabilidad y control corporal',
      'Mantener progresión sin necesidad de gimnasio'
    ]
  },

  // 5. MUJER - AVANZADO GYM
  'Plan Mujer Avanzado Gym': {
    titulo: 'Plan Avanzado Mujer – Gimnasio',
    categoriaKey: 'plan_avanzado_mujer_-_gimnasio',
    descripcion:
      'Este plan está diseñado para personas con experiencia que buscan maximizar resultados en fuerza, masa muscular y definición. Este plan presenta ejercicios que requieren mayor control corporal, un aumento de las cargas bajando las repeticiones para optimizar resultados. Entrenarás 4 días a la semana, con sesiones de aproximadamente 45 a 60 minutos. Incluye mayor volumen, ejercicios compuestos y trabajo específico. Para obtener resultados óptimos, es fundamental complementar con una alimentación adecuada, buen descanso y una correcta recuperación. Este plan no es recomendado para principiantes ni para personas con lesiones sin supervisión profesional.',
    comoUsar: [
      'Realiza primero el calentamiento en máquinas de cardio + movilización (video).',
      'Comienza con los músculos grandes, luego los pequeños.',
      'Mantén control técnico incluso con cargas altas.',
      'Los músculos fatigados deben tener descanso.',
      'Descansa entre 90 a 120 segundos.',
      'Mantén una buena hidratación.',
      'Finaliza con elongación (video).'
    ],
    carga: [
      'Ajusta la carga para que las últimas repeticiones cuesten, dejando 2–3 repeticiones en reserva.',
      'Si puedes completar todas las repeticiones, aumenta la carga progresivamente.',
      'Busca mejorar semana a semana en peso o rendimiento.'
    ],
    importante: [
      'Respira de forma consciente durante todo el entrenamiento. La respiración es fundamental para ejecutar cada ejercicio con seguridad y eficiencia. Inhala al preparar el movimiento y exhala durante la fase de mayor esfuerzo. Mantén un ritmo constante y evita contener el aire. Una buena respiración mejora el control, la estabilidad, el rendimiento y la correcta ejecución de cada ejercicio.',
      'Si no logras completar las repeticiones, disminuye la carga.',
      'Prioriza siempre la técnica antes de aumentar el peso.'
    ],
    objetivos: [
      'Maximizar desarrollo muscular y fuerza',
      'Aumentar fuerza en glúteos y piernas manteniendo el equilibrio con el tren superior',
      'Mejorar rendimiento general'
    ]
  },

  // 6. MUJER - AVANZADO CASA
  'Plan Mujer Avanzado Casa': {
    titulo: 'Plan Avanzado Mujer – Casa',
    categoriaKey: 'plan_avanzado_mujer_-_casa',
    descripcion:
      'Este plan está orientado a personas avanzadas que entrenan en casa y buscan un alto nivel de intensidad y exigencia. Incluye ejercicios complejos, mayor control corporal y uso de carga progresiva con mancuernas, discos, barras, TRX, etc. Incluye cargas altas, menor rango de repeticiones y ejercicios compuestos que requieren mayor control técnico. Para obtener resultados óptimos, es fundamental complementar con una alimentación adecuada, buen descanso y una correcta recuperación. Este plan no es recomendado para principiantes ni para personas con lesiones sin supervisión profesional. Entrenarás 4 días a la semana, con sesiones de aproximadamente 60 a 90 minutos.',
    comoUsar: [
      'Comienza con movilidad + cardio suave + activación de core.',
      'Comienza con los músculos grandes, luego los pequeños.',
      'Mantén control técnico incluso con cargas altas.',
      'Los músculos fatigados deben tener descanso.',
      'Descansa entre 90 a 120 segundos.',
      'Mantén una buena hidratación.',
      'Finaliza con elongación (video).'
    ],
    carga: [
      'Ajusta la carga para que las últimas repeticiones cuesten (2–3 en reserva).',
      'Si es posible, aumenta progresivamente el peso o la dificultad.',
      'Puedes aumentar intensidad controlando el ritmo del movimiento.'
    ],
    importante: [
      'Respira de forma consciente durante todo el entrenamiento. La respiración es fundamental para ejecutar cada ejercicio con seguridad y eficiencia. Inhala al preparar el movimiento y exhala durante la fase de mayor esfuerzo. Mantén un ritmo constante y evita contener el aire. Una buena respiración mejora el control, la estabilidad, el rendimiento y la correcta ejecución de cada ejercicio.',
      'Si no logras completar las repeticiones, disminuye la carga.',
      'Prioriza siempre la técnica antes de aumentar el peso.'
    ],
    objetivos: [
      'Mantener alto nivel de intensidad en casa',
      'Desarrollar fuerza y estabilidad',
      'Aumentar fuerza en glúteos y piernas manteniendo el equilibrio con el tren superior'
    ]
  },

  // 7. HOMBRE - BÁSICO GYM
  'Plan Hombre Basico Gym': {
    titulo: 'Plan Básico Hombre – Gimnasio',
    categoriaKey: 'plan_basico_hombre_-_gimnasio',
    descripcion:
      'Este plan está diseñado para hombres que están comenzando a entrenar o retomando la actividad física. Su objetivo es desarrollar fuerza general, mejorar la técnica y generar una base sólida de entrenamiento. Entrenarás 3 días a la semana, con sesiones de aproximadamente 45 a 60 minutos. El plan no solo busca mejorar tu condición física, sino también ayudarte a generar adherencia al entrenamiento a largo plazo. La constancia será clave para ver resultados, por lo que se recomienda complementar con una alimentación adecuada y buen descanso. A medida que avances, podrás progresar a planes de mayor intensidad. Este plan no es recomendado para personas con lesiones sin supervisión profesional.',
    comoUsar: [
      'Realiza primero el calentamiento (cardio + movilización).',
      'Ejecuta cada ejercicio con control, priorizando la técnica.',
      'Comienza con los músculos grandes, luego los pequeños.',
      'Descansa entre 60 a 90 segundos entre cada serie.',
      'Mantén una buena hidratación.',
      'Finaliza con elongación.'
    ],
    carga: [
      'Ajusta la carga para que las últimas repeticiones cuesten, dejando 2–3 repeticiones en reserva.',
      'Si puedes completar todas las repeticiones sin dificultad, aumenta la carga en la siguiente sesión.',
      'Busca progresar gradualmente en las cargas semana a semana.'
    ],
    importante: [
      'Respira de forma consciente durante todo el entrenamiento. La respiración es fundamental para ejecutar cada ejercicio con seguridad y eficiencia. Inhala al preparar el movimiento y exhala durante la fase de mayor esfuerzo. Mantén un ritmo constante y evita contener el aire. Una buena respiración mejora el control, la estabilidad, el rendimiento y la correcta ejecución de cada ejercicio.',
      'Si no logras completar las repeticiones, disminuye la carga.',
      'Prioriza siempre la técnica antes de aumentar el peso.'
    ],
    objetivos: [
      'Generar constancia en el entrenamiento',
      'Desarrollar fuerza general',
      'Aprender técnica de ejercicios',
      'Mejorar resistencia muscular'
    ]
  },

  // 8. HOMBRE - BÁSICO CASA
  'Plan Hombre Basico Casa': {
    titulo: 'Plan Básico Hombre – Casa',
    categoriaKey: 'plan_basico_hombre_-_casa',
    descripcion:
      'Este plan está enfocado en hombres que entrenan en casa utilizando implementos básicos como mancuernas, discos, TRX, etc. Su objetivo es desarrollar fuerza general, mejorar el control corporal y generar una base sólida de entrenamiento. Entrenarás 3 días a la semana, con sesiones de aproximadamente 45 a 60 minutos. El plan no solo busca mejorar tu condición física, sino también ayudarte a generar adherencia al entrenamiento a largo plazo desde casa. La constancia será clave para ver resultados, por lo que se recomienda complementar con una alimentación adecuada y buen descanso. A medida que avances, podrás progresar a planes de mayor intensidad o incorporar mayor carga y dificultad en los ejercicios. Este plan no es recomendado para personas con lesiones sin supervisión profesional.',
    comoUsar: [
      'Comienza con movilidad + cardio suave + activación de core.',
      'Comienza con los músculos grandes, luego los pequeños.',
      'Mantén control en cada repetición.',
      'Descansa entre 60 a 90 segundos.',
      'Mantén una buena hidratación.',
      'Finaliza con elongación.'
    ],
    carga: [
      'Ajusta la carga para que las últimas repeticiones cuesten (2–3 en reserva).',
      'Si es fácil, aumenta el peso o las repeticiones si puedes mantener buen ritmo y técnica.'
    ],
    importante: [
      'Respira de forma consciente durante todo el entrenamiento. La respiración es fundamental para ejecutar cada ejercicio con seguridad y eficiencia. Inhala al preparar el movimiento y exhala durante la fase de mayor esfuerzo. Mantén un ritmo constante y evita contener el aire. Una buena respiración mejora el control, la estabilidad, el rendimiento y la correcta ejecución de cada ejercicio.',
      'Si no logras completar las repeticiones, disminuye la carga.',
      'Prioriza siempre la técnica antes de aumentar el peso.'
    ],
    objetivos: [
      'Generar constancia en el entrenamiento',
      'Desarrollar fuerza en casa',
      'Mejorar control corporal',
      'Generar hábito de entrenamiento',
      'Trabajar coordinación'
    ]
  },

  // 9. HOMBRE - INTERMEDIO GYM
  'Plan Hombre Intermedio Gym': {
    titulo: 'Plan Intermedio Hombre – Gimnasio',
    categoriaKey: 'plan_intermedio_hombre_-_gimnasio',
    descripcion:
      'Este plan está diseñado para personas con nivel intermedio que ya tienen experiencia entrenando y buscan seguir progresando en fuerza, masa muscular y rendimiento. Incluye mayor volumen de entrenamiento, ejercicios más exigentes y un mayor control en la ejecución, permitiendo avanzar de forma progresiva en las cargas. Entrenarás 4 días a la semana, con sesiones de aproximadamente 45 a 60 minutos. Para obtener resultados óptimos, es fundamental complementar con una alimentación adecuada, buen descanso y una correcta recuperación. A medida que avances, podrás progresar hacia entrenamientos más intensos y específicos. Este plan no es recomendado para principiantes ni para personas con lesiones sin supervisión profesional. Resultados esperados: mejoras en fuerza, masa muscular y rendimiento en 4 a 6 semanas si se mantiene la constancia.',
    comoUsar: [
      'Realiza primero el calentamiento (cardio + movilización).',
      'Comienza con los músculos grandes luego los pequeños.',
      'Ejecuta cada ejercicio con control, priorizando la técnica.',
      'Descansa entre 60 a 90 segundos entre cada serie.',
      'Mantén una buena hidratación.',
      'Finaliza con elongación.'
    ],
    carga: [
      'Ajusta la carga para que las últimas repeticiones cuesten, dejando 2–3 repeticiones en reserva.',
      'Si puedes completar todas las repeticiones sin dificultad, aumenta la carga en la siguiente sesión.',
      'Busca progresar gradualmente en las cargas semana a semana.'
    ],
    importante: [
      'Respira de forma consciente durante todo el entrenamiento. La respiración es fundamental para ejecutar cada ejercicio con seguridad y eficiencia. Inhala al preparar el movimiento y exhala durante la fase de mayor esfuerzo. Mantén un ritmo constante y evita contener el aire. Una buena respiración mejora el control, la estabilidad, el rendimiento y la correcta ejecución de cada ejercicio.',
      'Si no logras completar las repeticiones, disminuye la carga.',
      'Prioriza siempre la técnica antes de aumentar el peso.'
    ],
    objetivos: [
      'Aumentar masa muscular',
      'Mejorar fuerza general',
      'Desarrollar control corporal',
      'Progresar en cargas de entrenamiento'
    ]
  },

  // 10. HOMBRE - INTERMEDIO CASA
  'Plan Hombre Intermedio Casa': {
    titulo: 'Plan Intermedio Hombre – Casa',
    categoriaKey: 'plan_intermedio_hombre_-_casa',
    descripcion:
      'Este plan está orientado a personas con nivel intermedio que entrenan en casa y buscan seguir avanzando en fuerza, control corporal y condición física. Incluye mayor volumen de entrenamiento, ejercicios más desafiantes y el uso de implementos como mancuernas y TRX etc. Entrenarás 3 días a la semana, con sesiones de aproximadamente 45 a 60 minutos. Este plan no solo busca mejorar tu condición física, sino también consolidar el hábito de entrenamiento desde casa sin depender de equipamiento avanzado, aumentando progresivamente la exigencia del entrenamiento. Para obtener resultados óptimos, es importante mantener una alimentación adecuada, buen descanso y constancia en el entrenamiento. A medida que avances, podrás aumentar la carga, dificultad o intensidad de los ejercicios según tu progreso. Este plan no es recomendado para principiantes ni para personas con lesiones sin supervisión profesional. Resultados esperados: mejoras en fuerza, control corporal y resistencia muscular en 4 a 6 semanas.',
    comoUsar: [
      'Comienza con movilidad + cardio suave + activación de core.',
      'Luego realiza el entrenamiento completo.',
      'Mantén control en cada repetición.',
      'Descansa entre 60 a 90 segundos entre cada serie.',
      'Finaliza con elongación.',
      'Mantén una buena hidratación.'
    ],
    carga: [
      'Ajusta la carga para que las últimas repeticiones cuesten (2–3 repeticiones en reserva).',
      'Si es fácil, aumenta el peso, las repeticiones o controla el ritmo del movimiento.',
      'Busca progresar gradualmente semana a semana.'
    ],
    importante: [
      'Respira de forma consciente durante todo el entrenamiento. La respiración es fundamental para ejecutar cada ejercicio con seguridad y eficiencia. Inhala al preparar el movimiento y exhala durante la fase de mayor esfuerzo. Mantén un ritmo constante y evita contener el aire. Una buena respiración mejora el control, la estabilidad, el rendimiento y la correcta ejecución de cada ejercicio.',
      'Si no logras completar las repeticiones, disminuye la carga.',
      'Prioriza siempre la técnica antes de aumentar el peso.'
    ],
    objetivos: [
      'Mejorar fuerza en casa',
      'Aumentar control y estabilidad',
      'Desarrollar resistencia muscular',
      'Mantener progresión sin necesidad de gimnasio'
    ]
  },

  // 11. HOMBRE - AVANZADO GYM
  'Plan Hombre Avanzado Gym': {
    titulo: 'Plan Avanzado Hombre – Gimnasio',
    categoriaKey: 'plan_avanzado_hombre_-_gimnasio',
    descripcion:
      'Este plan está diseñado para personas con experiencia avanzada que buscan maximizar su desarrollo muscular, fuerza y rendimiento. Los ejercicios están clasificados en cada sesión para obtener los resultados esperados. Incluye cargas altas, menor rango de repeticiones y ejercicios compuestos que requieren mayor control técnico. Para obtener resultados óptimos, es fundamental complementar con una alimentación adecuada, buen descanso y una correcta recuperación. Este plan no es recomendado para principiantes ni para personas con lesiones sin supervisión profesional. Entrenarás 4 días a la semana, con sesiones de aproximadamente 60 a 90 minutos.',
    comoUsar: [
      'Realiza primero el calentamiento (cardio + movilización).',
      'Comienza con los músculos grandes luego los pequeños.',
      'Mantén control técnico en todo momento, especialmente con cargas altas.',
      'Descansa entre 120 a 180 segundos entre cada serie.',
      'Mantén una buena hidratación.',
      'Finaliza con elongación.'
    ],
    carga: [
      'Ajusta la carga para que las últimas repeticiones cuesten, dejando 2–3 repeticiones en reserva.',
      'Si puedes completar todas las repeticiones, aumenta la carga progresivamente.',
      'Busca mejorar semana a semana en peso o rendimiento.'
    ],
    importante: [
      'Respira de forma consciente durante todo el entrenamiento. La respiración es fundamental para ejecutar cada ejercicio con seguridad y eficiencia. Inhala al preparar el movimiento y exhala durante la fase de mayor esfuerzo. Mantén un ritmo constante y evita contener el aire. Una buena respiración mejora el control, la estabilidad, el rendimiento y la correcta ejecución de cada ejercicio.',
      'Si no logras completar las repeticiones, disminuye la carga.',
      'Prioriza siempre la técnica antes de aumentar el peso.'
    ],
    objetivos: [
      'Maximizar desarrollo muscular',
      'Aumentar fuerza',
      'Mejorar rendimiento general',
      'Consolidar técnica en ejercicios avanzados'
    ]
  },

  // 12. HOMBRE - AVANZADO CASA
  'Plan Hombre Avanzado Casa': {
    titulo: 'Plan Avanzado Hombre – Casa',
    categoriaKey: 'plan_avanzado_hombre_-_casa',
    descripcion:
      'Este plan está orientado a personas avanzadas que entrenan en casa y buscan un alto nivel de intensidad y exigencia. Los ejercicios están clasificados en cada sesión para obtener los resultados esperados desde casa. Incluye ejercicios complejos, mayor control corporal y uso de carga progresiva con mancuernas, discos, barras, TRX, etc. Incluye cargas altas, menor rango de repeticiones y ejercicios compuestos que requieren mayor control técnico. Para obtener resultados óptimos, es fundamental complementar con una alimentación adecuada, buen descanso y una correcta recuperación. Este plan no es recomendado para principiantes ni para personas con lesiones sin supervisión profesional. Entrenarás 4 días a la semana, con sesiones de aproximadamente 60 a 90 minutos.',
    comoUsar: [
      'Comienza con movilidad + activación de core.',
      'Comienza con los músculos grandes luego los pequeños.',
      'Mantén control en cada repetición.',
      'Descansa entre 120 a 180 segundos.',
      'Mantén una buena hidratación.',
      'Finaliza con elongación.'
    ],
    carga: [
      'Ajusta la carga para que las últimas repeticiones cuesten (2–3 en reserva).',
      'Si es posible, aumenta progresivamente el peso o la dificultad.',
      'Puedes aumentar intensidad controlando el ritmo del movimiento.'
    ],
    importante: [
      'Respira de forma consciente durante todo el entrenamiento. La respiración es fundamental para ejecutar cada ejercicio con seguridad y eficiencia. Inhala al preparar el movimiento y exhala durante la fase de mayor esfuerzo. Mantén un ritmo constante y evita contener el aire. Una buena respiración mejora el control, la estabilidad, el rendimiento y la correcta ejecución de cada ejercicio.',
      'Si no logras completar las repeticiones, disminuye la carga.',
      'Prioriza siempre la técnica antes de aumentar el peso.'
    ],
    objetivos: [
      'Mantener alta intensidad en casa',
      'Desarrollar fuerza avanzada',
      'Mejorar estabilidad y control'
    ]
  }
};